import { Input } from '@dgshahr/ui-kit'
import { legalUserFields } from '@/data/merchant-register-forms/InfoStep'
import { FormikProps } from 'formik'
import { StoreType, TInfoFormValues } from '@/types/infoStep'

interface ILegalFormProps {
  formik: FormikProps<TInfoFormValues>
}

export const LegalForm = ({ formik }: ILegalFormProps) => {
  const { values, touched, errors, handleChange, handleBlur } = formik
  return (
    <section className="mt-4 p-4 desktop:grid desktop:grid-cols-3 gap-8 flex flex-col">
      {legalUserFields.map((field) => (
        <Input
          required={
            [
              'companyNationalId',
              'registrationNumber',
              'companyName',
              'storeBrandName',
              'signatoryOwners'
            ].includes(field.name) ||
            (field.name === 'website' &&
              (values.type === StoreType.ONLINE ||
                values.type === StoreType.BOTH))
          }
          key={field.id}
          name={field.name}
          id={field.id}
          placeholder={field.placeholder}
          postfix={field.postFix}
          dir={field.postFix ? 'ltr' : 'rtl'}
          onChange={handleChange}
          onBlur={handleBlur}
          value={String(values[field.name])}
          labelContent={field.labelContent}
          type={field.type}
          errorMessage={(touched[field.name] && errors[field.name]) || ''}
        />
      ))}
    </section>
  )
}
